import React from "react";
import { Modal, Button, Spinner, Alert } from "react-bootstrap";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { fetchActionsUtil, formatDate } from "../../utils/helpers";
import TableComponent from "../TableComponent";
import NoTableItem from "../utils/NoTableItem";
import { isEmpty } from "lodash";
import { PDFIcon } from "../Icons";

export default function ViewParticipantCertificateModal({
  enrollmentId,
  show,
  onHide,
}) {
  const { backendUrl, token } = useAuth();

  // Fetch certificates for the enrollment
  const fetchCertificates = async () => {
    try {
      const data = await fetchActionsUtil(
        `${backendUrl}/api/partnership/certificates?enrollment_id=${enrollmentId}`,
        "GET",
        token,
      );
      return data.data || data || [];
    } catch (error) {
      throw error;
    }
  };

  const { data: certificates, isLoading, isSuccess, error } = useQuery(
    ["GET_CERTIFICATES", enrollmentId],
    () => fetchCertificates(),
    {
      enabled: show && !!enrollmentId,
      keepPreviousData: true,
    },
  );

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          <th>Participant Name</th>
          <th>Email</th>
          <th>Certificate Number</th>
          <th>Issued Date</th>
          <th>Expiry Date</th>
          <th>Verification Code</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
    );
  };

  const tableData = (el) => {
    return (
      <>
        <td>{el?.full_name || "-"}</td>
        <td>{el?.participant?.email || "-"}</td>
        <td>{el?.certificate_number || "-"}</td>
        <td>{el?.issued_date ? formatDate(el.issued_date) : "-"}</td>
        <td>{el?.expiry_date ? formatDate(el.expiry_date) : "-"}</td>
        <td>{el?.verification_code || "-"}</td>
        <td>
          {el?.is_revoked === 0 ? (
            <span className="badge bg-success">Active</span>
          ) : (
            <span className="badge bg-danger">Revoked</span>
          )}
        </td>
        <td>
          {el?.pdf_url ? (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => window.open(el.pdf_url, "_blank")}
              title="View Certificate PDF"
            >
              <PDFIcon size={16} className="me-1" />
              View Certificate
            </Button>
          ) : (
            <span className="text-muted">No PDF</span>
          )}
        </td>
      </>
    );
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title as={"h6"}>Participant Certificates</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isLoading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2">Loading certificates...</p>
          </div>
        ) : error ? (
          <Alert variant="danger">
            {error?.message || "Error loading certificates"}
          </Alert>
        ) : isEmpty(certificates) ? (
          <NoTableItem queryParams={{ enrollmentId }} />
        ) : (
          <div className="table-responsive">
            <TableComponent
              responsive
              borderless
              striped
              tableHeadsFunction={tableHead}
              mainDataArray={certificates || []}
              className="product-table text-nowrap"
              tableDataRowFunction={tableData}
            />
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
